import React, { useState, createContext, useContext, useMemo } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { translations } from "@/i18n";

const LangCtx = createContext({ lang: "es", t: translations.es, setLang: () => {} });

export const useLang = () => useContext(LangCtx);

function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem("amplisoon_lang") || "es";
  });
  const value = useMemo(
    () => ({
      lang,
      t: translations[lang] || translations.es,
      setLang: (l) => {
        setLang(l);
        try { localStorage.setItem("amplisoon_lang", l); } catch {}
      },
    }),
    [lang]
  );
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </LanguageProvider>
    </div>
  );
}

export default App;
